export default "__VITE_ASSET__771f4d1b__"